import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash-message"
export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true },
    dismissAfter: { type: Number, default: 4000 }, // milliseconds
  };

  connect() {
    // Auto dismiss if enabled
    if (this.autoDismissValue) {
      this.dismissTimeout = setTimeout(() => {
        this.dismiss();
      }, this.dismissAfterValue);
    }
  }

  disconnect() {
    // Clear timeout if element is removed from DOM
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout);
    }
  }

  dismiss() {
    // Fade out animation
    this.element.classList.add("opacity-0");

    // Remove from DOM after animation completes
    setTimeout(() => {
      this.element.remove();
    }, 500); // should match transition duration in CSS
  }
}
